/**
 * Extract expiration claim from JWT token
 * @param token - JWT token
 * @returns expiration timestamp in seconds, or null if not found
 */
export function getTokenExpClaim(token: string): number | null {
  const payload = decodeJWTPayload(token)
  return payload && typeof payload.exp === "number" ? payload.exp : null
}

/**
 * Decode JWT payload without signature verification
 * @param token - JWT token
 * @returns decoded payload object
 */
function decodeJWTPayload(token: string): Record<string, unknown> | null {
  const parts = token.split(".")
  if (parts.length !== 3) throw new Error("Invalid JWT format")
  const payload = parts[1] ?? ""
  const json = base64UrlDecode(payload)
  return JSON.parse(json)
}

/**
 * Decode base64url string to UTF-8 string
 * Works in both browser and Node.js environments
 * @param str - base64url encoded string
 * @returns decoded UTF-8 string
 */
function base64UrlDecode(str: string): string {
  // Convert base64url to standard base64
  let base64Str = str.replace(/-/g, "+").replace(/_/g, "/")

  // Add padding if needed
  while (base64Str.length % 4) base64Str += "="

  if (
    typeof globalThis !== "undefined" &&
    typeof (globalThis as { atob?: (input: string) => string }).atob === "function"
  ) {
    // Browser or environments with atob
    return decodeURIComponent(
      Array.prototype.map
        .call(
          (globalThis as { atob: (input: string) => string }).atob(base64Str),
          (c: string) => `%${("00" + c.charCodeAt(0).toString(16)).slice(-2)}`
        )
        .join("")
    )
  }
  if (typeof Buffer !== "undefined") {
    // Node.js environment
    return Buffer.from(base64Str, "base64").toString("utf-8")
  }
  throw new Error("No base64 decoder available")
}
